export default __webpack_public_path__ + "static/media/51e8e8b00920a6769df8efbdf652f76e.svg";